var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2568 7.13738C21.0398 6.90332 20.7451 6.77178 20.4379 6.77178C20.1306 6.77178 19.836 6.90332 19.619 7.13738L13.9389 13.2374L8.25882 7.12488C8.0418 6.89082 7.74717 6.75928 7.43991 6.75928C7.13266 6.75928 6.83803 6.89082 6.62101 7.12488C6.168 7.61238 6.168 8.39988 6.62101 8.88738L12.3011 14.9999L6.62101 21.1124C6.168 21.5999 6.168 22.3874 6.62101 22.8749C7.07402 23.3624 7.80581 23.3624 8.25882 22.8749L13.9389 16.7624L19.619 22.8749C20.072 23.3624 20.8038 23.3624 21.2568 22.8749C21.7098 22.3874 21.7098 21.5999 21.2568 21.1124L15.5767 14.9999L21.2568 8.88738C21.6982 8.41238 21.6982 7.61238 21.2568 7.13738Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.31f1dccb.svg";
export { ForwardRef as ReactComponent };